import * as React from 'react';
import { ArticleHeading1, ArticleHeading2, useDeviceType } from '@cian/ui-kit';

import { Link } from '../Link';

export interface ITitleProps {
  newbuildingName: string;
  newbuildingLink: string;
}

export const TitleComponent: React.FC<ITitleProps> = props => {
  const { newbuildingName, newbuildingLink } = props;
  const deviceType = useDeviceType();
  /* istanbul ignore next */
  const Heading = deviceType === 'desktop' ? ArticleHeading1 : ArticleHeading2;

  return (
    <Heading as="h1">
      Отзывы и вопросы о&nbsp;
      <Link inline url={newbuildingLink}>
        ЖК&nbsp;«{newbuildingName}»
      </Link>
    </Heading>
  );
};

export const Title = React.memo(TitleComponent);
